import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, uploadImage, fileUrl } from "@/lib/api";
import { PageHeader, Card, Loading, Button, Modal, Field, Pill, EmptyState } from "@/components/kit";
import { Plus, Trash2, Gift, Image as ImageIcon } from "lucide-react";

export default function RewardsPromos() {
  const [tab, setTab] = useState("rewards");
  const [rewards, setRewards] = useState(null);
  const [promos, setPromos] = useState(null);
  const [showReward, setShowReward] = useState(false);
  const [showPromo, setShowPromo] = useState(false);

  const load = () => {
    api.getRewards().then(setRewards).catch(() => setRewards([]));
    api.ownerPromos().then(setPromos).catch(() => setPromos([]));
  };
  useEffect(() => { load(); }, []);

  const delReward = async (id) => { if (!window.confirm("Hapus reward?")) return; try { await api.deleteReward(id); toast.success("Terhapus"); load(); } catch (e) { toast.error(e.message); } };
  const delPromo = async (id) => { if (!window.confirm("Hapus promo?")) return; try { await api.deletePromo(id); toast.success("Terhapus"); load(); } catch (e) { toast.error(e.message); } };

  return (
    <div>
      <PageHeader eyebrow="Owner" title="Rewards & Promo" subtitle="Kelola katalog reward poin dan banner promo untuk member."
        right={tab === "rewards"
          ? <Button onClick={() => setShowReward(true)} data-testid="add-reward"><Plus className="h-4 w-4" /> Reward</Button>
          : <Button onClick={() => setShowPromo(true)} data-testid="add-promo"><Plus className="h-4 w-4" /> Promo</Button>} />

      <div className="mb-6 flex gap-2">
        <Pill active={tab === "rewards"} onClick={() => setTab("rewards")}>Rewards</Pill>
        <Pill active={tab === "promos"} onClick={() => setTab("promos")}>Promo Banner</Pill>
      </div>

      {tab === "rewards" ? (
        rewards === null ? <Loading /> : !rewards.length ? <EmptyState icon={Gift} title="Belum ada reward" /> : (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {rewards.map((r) => (
              <Card key={r.id} className="p-0 overflow-hidden">
                {r.image_path && <img src={fileUrl(r.image_path)} alt={r.title} className="h-36 w-full object-cover" />}
                <div className="p-4">
                  <div className="text-white">{r.title}</div>
                  <div className="mt-1 text-sm text-[#E7C25B]">{r.points_cost} poin</div>
                  <button className="mt-3 flex items-center gap-1 text-[12px] text-[#8E8E93] hover:text-[#FF6B6B]" onClick={() => delReward(r.id)}><Trash2 className="h-3.5 w-3.5" /> Hapus</button>
                </div>
              </Card>
            ))}
          </div>
        )
      ) : (
        promos === null ? <Loading /> : !promos.length ? <EmptyState icon={ImageIcon} title="Belum ada promo" /> : (
          <div className="grid gap-4 sm:grid-cols-2">
            {promos.map((p) => (
              <Card key={p.id} className="p-0 overflow-hidden">
                {p.image_path && <img src={fileUrl(p.image_path)} alt={p.title} className="h-40 w-full object-cover" />}
                <div className="flex items-center justify-between p-4">
                  <span className="text-white">{p.title || "Promo"}</span>
                  <button className="text-[#8E8E93] hover:text-[#FF6B6B]" onClick={() => delPromo(p.id)}><Trash2 className="h-4 w-4" /></button>
                </div>
              </Card>
            ))}
          </div>
        )
      )}

      {showReward && <RewardModal onClose={() => setShowReward(false)} onSaved={() => { setShowReward(false); load(); }} />}
      {showPromo && <PromoModal onClose={() => setShowPromo(false)} onSaved={() => { setShowPromo(false); load(); }} />}
    </div>
  );
}

function useUpload() {
  const ref = useRef(null);
  const [path, setPath] = useState("");
  const [preview, setPreview] = useState("");
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true); setPreview(URL.createObjectURL(file));
    try { const r = await uploadImage(file); setPath(r.path); toast.success("Gambar diunggah"); }
    catch (err) { toast.error(err.message); } finally { setBusy(false); }
  };
  const El = (
    <div>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} />
      <button type="button" onClick={() => ref.current?.click()} className="flex h-32 w-full items-center justify-center rounded-xl border border-dashed border-[#2C2C2E] bg-[#0E0E10] text-sm text-[#6E6E73] hover:border-[#6E6E73]" data-testid="upload-image">
        {busy ? "Mengunggah..." : preview ? <img src={preview} alt="" className="h-full w-full rounded-xl object-cover" /> : "+ Pilih gambar"}
      </button>
    </div>
  );
  return { path, El };
}

function RewardModal({ onClose, onSaved }) {
  const [title, setTitle] = useState("");
  const [points, setPoints] = useState("");
  const { path, El } = useUpload();
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!title.trim() || !Number(points)) return toast.error("Judul & poin wajib diisi");
    setBusy(true);
    try { await api.createReward({ title: title.trim(), points_cost: Number(points), image_path: path || undefined }); toast.success("Reward dibuat"); onSaved(); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <Modal open title="Reward Baru" onClose={onClose}>
      <div className="space-y-4">
        <Field label="Gambar">{El}</Field>
        <Field label="Judul"><input className="hsc-input" value={title} onChange={(e) => setTitle(e.target.value)} data-testid="reward-title" /></Field>
        <Field label="Biaya Poin"><input type="number" className="hsc-input" value={points} onChange={(e) => setPoints(e.target.value)} data-testid="reward-points" /></Field>
        <div className="flex justify-end gap-2 pt-2"><Button variant="ghost" onClick={onClose}>Batal</Button><Button onClick={save} disabled={busy} data-testid="reward-save">Simpan</Button></div>
      </div>
    </Modal>
  );
}

function PromoModal({ onClose, onSaved }) {
  const [title, setTitle] = useState("");
  const { path, El } = useUpload();
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!path) return toast.error("Unggah gambar promo dulu");
    setBusy(true);
    try { await api.createPromo({ title: title.trim() || undefined, image_path: path }); toast.success("Promo dibuat"); onSaved(); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <Modal open title="Promo Baru" onClose={onClose}>
      <div className="space-y-4">
        <Field label="Banner">{El}</Field>
        <Field label="Judul (opsional)"><input className="hsc-input" value={title} onChange={(e) => setTitle(e.target.value)} /></Field>
        <div className="flex justify-end gap-2 pt-2"><Button variant="ghost" onClick={onClose}>Batal</Button><Button onClick={save} disabled={busy}>Simpan</Button></div>
      </div>
    </Modal>
  );
}
